import { http } from './config';

const OS_PATH = 'ordemDeServico';

export default {
  listar: object => {
    let params = `page=${object.page ? object.page : 1}`;
    if (object.codigo) {
      params += `&codigo=${object.codigo}`;
    }
    if (object.nome) {
      params += `&nome=${object.nome}`;
    }
    return http.get(`${OS_PATH}?${params}`);
  },
  deletar: os => http.delete(`${OS_PATH}/${os._id}`),
  atualizar: os => http.post(`${OS_PATH}/${os._id}`, os),
  getByCodigo: codigo => http.get(`${OS_PATH}/${codigo}`),
  salvar: os => http.post(OS_PATH, os),
  getColaboradoresDeCampoDisponiveis: () =>
    http.get(`${OS_PATH}/colaboradores-campo/disponiveis`),
  getOsParaAprovacao: colaboradorDeCampo =>
    http.get(`${OS_PATH}/aprovacao/${colaboradorDeCampo}`),
  aprovarOuNegarOs: (colaboradorDeCampo, aprovada) =>
    http.post(`${OS_PATH}/aprovacao/${colaboradorDeCampo}/aprovar`, {
      aprovada
    })
};
